import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/DocsSidebar.tsx");
